<template>
    <div class="slide trivia-4">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="1"
                    :total="3"
                    :className="className" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-5",
            className: "trivia-4",
            currentTrivia: 4,
            questions: {
                question: {
                    "title": "After confirming the license plate number from a BOLO and locating the address for the registered owner, what is the Investigator’s next step?",
                    "answers": [
                        {"key": "A", "answer": "Call law enforcement"},
                        {"key": "B", "answer": "Conduct a preliminary site assessment"},
                        {"key": "C", "answer": "Give store associates permission to conduct an apprehension"},
                        {"key": "D", "answer": "Take out a warrant on the suspect"}
                    ],
                    "correctAnswer": ["B"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">
.trivia-4 {
    padding: 20px 35px;

    h1 {
        font-size: 24px !important;
        line-height: 1.2;
    }
}
</style>
